module.exports = __webpack_public_path__ + "img/performing_en.ea80f94.jpg";